export default {
    task: {
        getMyCash: 'माझी रोकड मिळवा',
        chances: 'शक्यता शेष',
        tips: 'कार्ड मिळविण्यासाठी टिपा',
        daily: 'दररोज तपासणी',
        watch: 'कोणताही व्हिडिओ पहा',
        share: 'स्पर्धा शेअर करा',
        free: 'विनामूल्य रोकड आणि कार्ड +1',
        done: 'झाले',
        go: 'जा',
        success: 'यशस्वीरित्या',
        checkIn: 'प्रवेश सुनिश्चित',
        successCheckIn: 'यशस्वीरित्या चेक इन केले!',
        successWatched: 'यशस्वीरित्या पाहिले!',
        successShared: ' यशस्वीरित्या शेअर केले!',
        won: 'तुम्ही जिंकलात',
        card: 'कार्ड',
        msg: 'पैसे तुमच्या खात्यामध्ये जमा झाले',
        ok: 'ठीक आहे',

        nochance: 'आपण सर्व समाप्त केले नाही',
        cards: '४ कार्ड्स ',
        collection:'संग्रह',
        watchVideo:'व्हिडिओ पहा ',
        toGet:'अधिक कार्ड मिळवण्यासाठी'
    },
    
    rules: {
        ruleTitle: "नियम",
        validityDate: "वैधता तारीख: 8 मार्च, 2020 - 15 मार्च 2020",
        prizeRedeem: "पुरस्कार पूर्तताः एकदा शिल्लक 15 रूपये पर्यंत पोहोचल्यावर वापरकर्ते त्यांची रोख रक्कम काढू शकतात, व्यवहार 7  दिवसांच्या आत पूर्ण होतीलगेमचे",
        gameRule:{
            title:"नियमः",
            ruleList: [
                "1. जेव्हा दररोज तपासणी केली जाते तेव्हा वापरकर्त्यांना रोकड आणि 1 कार्ड मिळू शकते",
                "2. जेव्हा दररोज कोणताही व्हिडिओ पाहणे संपेल तेव्हा वापरकर्त्यांना रोकड आणि 1 कार्ड मिळू शकते",
                "3. व्हॉअट्सॅप ग्रुप किंवा फेसबुक किंवा इन्स्टाग्रामवर क्रियाकलाप शेअर करणे समाप्त झाल्यावर वापरकर्त्यांना रोकड आणि 1 कार्ड मिळू शकते",
                "4. एकदा सर्व 4 कार्डे एकत्रित केल्यानंतर वापरकर्त्यांना लॉटरी काढण्याची संधी मिळू शकेल. प्रत्येक लकी ड्रॉ म्हणजे 3 मिलियन रूपयेचे रोकड तलावातील 100% - निश्चित-विजय लकी ड्रॉ, प्रत्येक वापरकर्ता जास्तीत जास्त 20000 रुपये काढू शकतोअंतिम स्पष्टीकरणासाठी"
            ]
        },
        msg:"SHAREit सर्व अधिकार राखून ठेवते"
    },
    share: {
        title:"*गंमत नाही, मित्रा, ही होळी, SHAREit चा 30 लाखांचा खरी रोकड रक्कमचा गिवअवे!*😊\n*माझ्यासह सामील व्हा आणि 20000 रूपये पर्यंत मिळविण्यासाठी व्हिडिओ पहा, प्रत्येकजण 100% जिंकतो.*💰\n*मला आधीच मोफत रोकड मिळाली आहे, ती 100% खरी आहे.*\n*चला आताच SHAREit होळी स्पर्धेत सामील होऊ!*💕👇🏻👇🏻👇🏻"
    }
}